document.addEventListener('DOMContentLoaded', function() {
  function initContactForm() {
    // 1. Strict input filtering (Event Delegation)
    document.addEventListener('input', function(e) {
      if (!e.target || !e.target.id) return;
      
      // Full Name filtering
      if (e.target.id.indexOf('cf-name-') === 0) {
        e.target.value = e.target.value.replace(/[^a-zA-Z\s\-.]/g, '');
      }
      // Phone filtering
      if (e.target.id.indexOf('cf-phone-') === 0) {
        e.target.value = e.target.value.replace(/[^\d]/g, '');
      }
    });

    // 2. Validation Logic
    function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); }
    function isName(v) { 
      var val = v.trim();
      if (val.length === 0) return false;
      return /[a-zA-Z]/.test(val) && !/\d/.test(val); 
    }
    function isPhone(v) {
      var val = v.trim();
      if (val.length === 0) return true;
      return /^\d{10}$/.test(val);
    }

    function setInvalid(input, errEl) {
      input.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
      if (errEl) errEl.classList.add('is-visible');
    }
    function clearInvalid(input, errEl) {
      input.classList.remove('is-invalid');
      input.removeAttribute('aria-invalid');
      if (errEl) errEl.classList.remove('is-visible');
    }

    // 3. Blur / Input live validation (Event Delegation)
    document.addEventListener('blur', function(e) {
      if (!e.target || !e.target.id) return;
      var target = e.target;
      var errEl = document.getElementById(target.id + '-err');
      if (!errEl) return;

      if (target.id.indexOf('cf-name-') === 0) {
        isName(target.value) ? clearInvalid(target, errEl) : setInvalid(target, errEl);
      }
      if (target.id.indexOf('cf-email-') === 0) {
        isEmail(target.value) ? clearInvalid(target, errEl) : setInvalid(target, errEl);
      }
      if (target.id.indexOf('cf-phone-') === 0) {
        isPhone(target.value) ? clearInvalid(target, errEl) : setInvalid(target, errEl);
      }
      if (target.id.indexOf('cf-message-') === 0) {
        target.value.trim().length > 0 ? clearInvalid(target, errEl) : setInvalid(target, errEl);
      }
    }, true);

    document.addEventListener('input', function(e) {
      if (!e.target || !e.target.id) return;
      var target = e.target;
      var errEl = document.getElementById(target.id + '-err');
      if (!errEl) return;

      if (target.id.indexOf('cf-name-') === 0 && isName(target.value)) clearInvalid(target, errEl);
      if (target.id.indexOf('cf-email-') === 0 && isEmail(target.value)) clearInvalid(target, errEl);
      if (target.id.indexOf('cf-phone-') === 0 && isPhone(target.value)) clearInvalid(target, errEl);
      if (target.id.indexOf('cf-message-') === 0 && target.value.trim().length > 0) clearInvalid(target, errEl);
    });

    document.addEventListener('change', function(e) {
      if (!e.target || !e.target.id) return;
      if (e.target.id.indexOf('cf-subject-') === 0) {
        var errEl = document.getElementById(e.target.id + '-err');
        if (e.target.value && errEl) clearInvalid(e.target, errEl);
      }
    });

    // 4. Submit interception
    document.addEventListener('submit', function(e) {
      if (!e.target || !e.target.id) return;
      if (e.target.id.indexOf('ContactForm-') !== 0) return;

      var formEl = e.target;
      var sid = formEl.id.replace('ContactForm-', '');
      var successBox = document.getElementById('cf-success-' + sid);
      var errorBox = document.getElementById('cf-top-error-' + sid);
      var submitBtn = document.getElementById('cf-submit-' + sid);

      var valid = true;
      if (successBox) successBox.classList.remove('is-visible');
      if (errorBox) errorBox.classList.remove('is-visible');

      var nameInp = document.getElementById('cf-name-' + sid);
      if (nameInp && !isName(nameInp.value)) { setInvalid(nameInp, document.getElementById('cf-name-err-' + sid)); valid = false; }
      
      var emailInp = document.getElementById('cf-email-' + sid);
      if (emailInp && !isEmail(emailInp.value)) { setInvalid(emailInp, document.getElementById('cf-email-err-' + sid)); valid = false; }

      var phoneInp = document.getElementById('cf-phone-' + sid);
      if (phoneInp && !isPhone(phoneInp.value)) { setInvalid(phoneInp, document.getElementById('cf-phone-err-' + sid)); valid = false; }

      var subjectSel = document.getElementById('cf-subject-' + sid);
      if (subjectSel && !subjectSel.value) { setInvalid(subjectSel, document.getElementById('cf-subject-err-' + sid)); valid = false; }

      var msgInp = document.getElementById('cf-message-' + sid);
      if (msgInp && msgInp.value.trim() === '') { setInvalid(msgInp, document.getElementById('cf-message-err-' + sid)); valid = false; }

      if (!valid) {
        e.preventDefault();
        if (errorBox) errorBox.classList.add('is-visible');
        var first = formEl.querySelector('.is-invalid');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        // fallback text if setting is empty
        var sendingText = submitBtn.getAttribute('data-sending-text') || 'Sending...';
        submitBtn.textContent = sendingText;
      }
    });
  }

  // Ensure it runs once
  if (!window.vwashContactFormInitialized) {
    initContactForm();
    window.vwashContactFormInitialized = true;
  }
});
